import { ComponentPropsWithoutRef } from 'react'

export const EditEvaluationIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.736 3.1124C10.8773 2.97111 11.045 2.85903 11.2296 2.78257C11.4142 2.7061 11.6121 2.66675 11.8119 2.66675C12.0117 2.66675 12.2095 2.7061 12.3941 2.78257C12.5787 2.85903 12.7465 2.97111 12.8878 3.1124C13.0291 3.25369 13.1411 3.42142 13.2176 3.60602C13.2941 3.79063 13.3334 3.98848 13.3334 4.1883C13.3334 4.38811 13.2941 4.58596 13.2176 4.77057C13.1411 4.95517 13.0291 5.1229 12.8878 5.26419L5.62546 12.5265L2.66675 13.3334L3.47367 10.3747L10.736 3.1124Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
